import React, { useState, useEffect } from 'react';
import { X, MessageCircle, Clock } from 'lucide-react';

const WHATSAPP_URL = 'https://wa.me/917757999805?text=Hi%20Aquarist%20Pools%20and%20Fitness%2C%20I%20am%20interested%20in%20a%20FREE%20site%20consultation%20for%20my%20pool%20project.';

const LeadPopup = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const seen = sessionStorage.getItem('aquarist_popup_seen');
    if (seen) return;

    const timer = setTimeout(() => {
      setShow(true);
      sessionStorage.setItem('aquarist_popup_seen', '1');
    }, 6000);

    return () => clearTimeout(timer);
  }, []);

  const trackClick = (label) => {
    if (window.gtag) window.gtag('event', 'click', { event_category: 'CTA', event_label: label });
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center p-4" style={{ zIndex: 99998 }} data-testid="lead-popup-overlay">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={() => setShow(false)} />
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden animate-in fade-in zoom-in-95 duration-300" data-testid="lead-popup">
        {/* Header */}
        <div className="relative bg-gradient-to-br from-[#003366] to-[#001a33] p-6 pb-8">
          <button
            onClick={() => setShow(false)}
            className="absolute top-3 right-3 w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white/70 hover:text-white transition-colors"
            data-testid="lead-popup-close"
          >
            <X className="w-4 h-4" />
          </button>
          <div className="flex items-center gap-2 text-[#00AEEF] text-xs font-semibold mb-3">
            <Clock className="w-3.5 h-3.5" />
            LIMITED SLOTS THIS MONTH
          </div>
          <h3 className="text-2xl font-bold text-white mb-1">Planning a Pool?</h3>
          <p className="text-gray-300 text-sm">Get a <strong className="text-[#00AEEF]">FREE site consultation</strong> from Bangalore's top pool builders.</p>
        </div>

        {/* Body */}
        <div className="p-6">
          <div className="space-y-3 mb-6">
            {[
              'Free site evaluation & design consultation',
              'Transparent pricing — no hidden costs',
              'Expert advice from 15+ years experience'
            ].map((item, i) => (
              <div key={i} className="flex items-start gap-2.5">
                <div className="w-5 h-5 rounded-full bg-[#00AEEF]/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <div className="w-2 h-2 rounded-full bg-[#00AEEF]" />
                </div>
                <p className="text-sm text-gray-600">{item}</p>
              </div>
            ))}
          </div>

          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackClick('lead_popup_whatsapp')}
            className="flex items-center justify-center gap-2.5 w-full bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold py-3.5 rounded-xl transition-all duration-200 hover:scale-[1.02] shadow-lg shadow-[#25D366]/25 text-base"
            data-testid="lead-popup-whatsapp"
          >
            <MessageCircle className="w-5 h-5 fill-white" />
            Chat on WhatsApp
          </a>

          <div className="flex items-center gap-3 mt-4">
            <div className="flex-1 h-px bg-gray-200" />
            <span className="text-xs text-gray-400">or</span>
            <div className="flex-1 h-px bg-gray-200" />
          </div>

          <a
            href="tel:+917757999805"
            onClick={() => trackClick('lead_popup_call')}
            className="flex items-center justify-center gap-2 w-full border-2 border-[#003366] text-[#003366] font-semibold py-3 rounded-xl mt-4 hover:bg-[#003366]/5 transition-colors text-sm"
            data-testid="lead-popup-call"
          >
            Call for Consultation: +91 77579 99805
          </a>
        </div>
      </div>
    </div>
  );
};

export default LeadPopup;
